import { Select, Button, Row, Col, Input } from "antd";
import React, { Component } from "react";

export default class SoTo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,

      selectedQuan: undefined,
      selectedPhuong: undefined,

      SoThua: undefined,
      SoTo: undefined,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listQuan !== this.props.listQuan) {
      this.setState({ listQuan: this.props.listQuan });
    }

    if (prevProps.listPhuong !== this.props.listPhuong) {
      this.setState({ listPhuong: this.props.listPhuong });
    }
  }

  onChangeQuan(value) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan == value);

    this.setState({
      selectedQuan: value,
      selectedPhuong: undefined,
      listPhuong: listPhuong,
    });
  }

  onChangePhuong(value, option) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan == option.IDQuan);
    let selectedQuan = this.state.listQuan.filter(
      (e) => e.MAHUYEN == option.IDQuan
    );
    this.setState({
      selectedQuan:
        selectedQuan && selectedQuan.length !== 0
          ? selectedQuan[0].MAHUYEN
          : undefined,
      selectedPhuong: value,
      listPhuong: listPhuong,
    });
  }

  onResetButton() {
    this.setState({
      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,
      selectedQuan: undefined,
      selectedPhuong: undefined,
      SoThua: undefined,
      SoTo: undefined,
    });
  }

  onSearch = () => {
    let data = {
      selectedPhuong: this.state.selectedPhuong,
      SoThua: this.state.SoThua,
      SoTo: this.state.SoTo,
    };
    this.props.onSearch(data);
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <div>
          <div className="group">
            <div className="gr-title">
              <div className="required">*</div>
              <div className="text">Quận/Huyện</div>
            </div>

            <div className="gr-body">
              <Select
                className="select"
                showSearch
                value={this.state.selectedQuan}
                onChange={(value) => this.onChangeQuan(value)}
                optionFilterProp = "name"
              >
                {this.state.listQuan.map((e, i) => (
                  <Select.Option value={e.MAHUYEN} key={i} name = {e.TENHUYEN}>
                    {e.TENHUYEN}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>

          <div className="group">
            <div className="gr-title">
              <div className="required">*</div>
              <div className="text">Phường/Xã</div>
            </div>

            <div className="gr-body">
              <Select
                className="select"
                showSearch
                onChange={(value, option) => this.onChangePhuong(value, option)}
                optionFilterProp = "name"
                value={this.state.selectedPhuong}
              >
                {this.state.listPhuong.map((e, i) => (
                  <Select.Option value={e.MaPhuong} IDQuan={e.MaQuan} key={i} name = {e.TenPhuong}>
                    {e.TenPhuong}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>

          <Row gutter={[10, 0]}>
            <Col span={12}>
              <div className="group">
                <div className="gr-title">
                  <div className="required">*</div>
                  <div className="text">Số hiệu thửa đất</div>
                </div>

                <div className="gr-body">
                  <Input
                    className="input"
                    value={this.state.SoThua}
                    onChange={(e) => {
                      this.setState({ SoThua: e.target.value });
                    }}
                  ></Input>
                </div>
              </div>
            </Col>

            <Col span={12}>
              <div className="group">
                <div className="gr-title">
                  <div className="required">*</div>
                  <div className="text">Số tờ bản đồ</div>
                </div>

                <div className="gr-body">
                  <Input
                    className="input"
                    value={this.state.SoTo}
                    onChange={(e) => {
                      this.setState({ SoTo: e.target.value });
                    }}
                  ></Input>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="primary"
            className="button"
            onClick={() => {
              this.onResetButton();
            }}
          >
            Tìm mới
          </Button>
          <Button
            type="primary"
            className="button"
            disabled={
              this.state.selectedPhuong &&
              this.state.selectedQuan &&
              this.state.SoThua &&
              this.state.SoTo
                ? false
                : true
            }
            onClick={this.onSearch}
          >
            Tìm kiếm
          </Button>
        </div>
      </div>
    );
  }
}
